var lx = lx || {};
lx.cdo = lx.cdo || {};

/*Procurement Functions*/
/*ex cdoPaymentForm function*/
lx.cdo.PaymentForm = function (pId, pMarkAsPaid, pThis) {
    lx.load.add();
   /* lx.util.loadFile("/i/libraries/apex/minified/widget.datepicker.min.js?v=5.0.3.00.03", "js");
    lx.util.loadFile("/i/libraries/jquery-ui/1.10.4/ui/i18n/oracle/jquery.ui.datepicker-en-us.js?v=5.0.3.00.03", "js");*/
	
	/* lx.util.loadFile("/i/dist/plugin/jquery-ui/1.12.1/ui/widgets/minified/datepicker.min.js?v=20.1.0.00.13", "js");
	 lx.util.loadFile("/i/dist/plugin/jquery-ui/1.12.1/ui/widgets/datepicker.js?v=20.1.0.00.13", "js");*/
    // lx.util.loadFile("/i/dist/plugin/jquery-ui/1.12.1/ui/i18n/oracle/jquery.ui.datepicker-en-us.js?v=20.1.0.00.13", "js");
	 lx.util.loadFile("/i/libraries/apex/minified/widget.datepicker.min.js?v=20.1.0.00.13", "js");
	
    $.ajax({
        url: "wwv_flow.show",
        dataType: "html",
        traditional: true,
        cache: false,
        type: "POST",
        data: {
            p_flow_id: $v("pFlowId"),
            p_flow_step_id: $v("pFlowStepId"),
            p_instance: $v("pInstance"),
            p_request: "APPLICATION_PROCESS=cdoPaymentForm",
            x01: pId,
            x02: pMarkAsPaid
        },
        success: function (d) {
            lx.load.remove();
            lxpDialog.open({ id: "cdoPaymentForm", html: d, title: lx.tran.get('MANAGE_PAYMENTS'), maxWidth: "640px" });
            apex.widget.datepicker(".lxCdoPayDate", {
                "buttonImageOnly": false,
                "buttonText": "\u003Cspan class=\u0022a-Icon icon-calendar\u0022\u003E\u003C\u002Fspan\u003E\u003Cspan class=\u0022u-VisuallyHidden\u0022\u003EPopup Calendar: Date\u003Cspan\u003E",
                "showTime": false,
                "defaultDate": new Date(),
                "showOn": "button",
                "showOtherMonths": false,
                "changeMonth": false,
                "changeYear": false
            }, "mm\u002Fdd\u002Fyy", "en-us");
            $('.lxCdoPayDate').next('button').addClass('a-Button a-Button--calendar lxCdoPayPicker');
            if (pMarkAsPaid == 1) lx.cdo.submitPayment(true, pThis);
        }
    });
};
var lxCdoPaymentRow;
var lxCdoPaymentRow1;
var lxCdoPaymentRow2;

/* ex addCdoPaymentRow function*/
lx.cdo.addPaymentRow = function () {
    $(".lxCdoPayNoRows").remove();
    //$(".lxCdoPayments table > tfoot").append(lxCdoPaymentRow);
	var RowCnt = $('.lxCdoPayDate').length+1;
	lxCdoPaymentRow = lxCdoPaymentRow1+RowCnt+lxCdoPaymentRow2;
	$("#lxCdoPayment").append(lxCdoPaymentRow);
    apex.widget.datepicker(".lxCdoPayDate", { //.lxCdoPayments table > tfoot tr:last-child .lxCdoPayDate 
        "buttonImageOnly": false,
        "buttonText": "\u003Cspan class=\u0022a-Icon icon-calendar\u0022\u003E\u003C\u002Fspan\u003E\u003Cspan class=\u0022u-VisuallyHidden\u0022\u003EPopup Calendar: Date\u003Cspan\u003E",
        "showTime": false,
        "defaultDate": new Date(),
        "showOn": "button",
        "showOtherMonths": false,
        "changeMonth": false,
        "changeYear": false
    }, "mm\u002Fdd\u002Fyy", "en-us");
	$('.lxCdoPayDate').next('button').addClass('a-Button a-Button--calendar lxCdoPayPicker');
   // $('.lxCdoPayments table > tfoot tr:last-child .lxCdoPayDate').next('button').addClass('a-Button a-Button--calendar'); //.lxCdoPayments table > tfoot tr:last-child .lxCdoPayDate
    //$('lxCdoPayments table > tfoot tr:last-child .lxCdoPayAmount').val($("#lxCdoPayBalance").text().replace('-', '')); //lxCdoPayments table > tfoot tr:last-child .lxCdoPayAmount
    lx.btn.hightlight('lxCdoPaySave');
    lx.cdo.PaymentUpdateTotal();
};


/* ex cdoPaymentUpdateTotal function*/
lx.cdo.PaymentUpdateTotal = function () {
	//alert($("#lxCdoPayTotalDoc").text());
    var lTotalDoc = lx.util.strToNumber($("#lxCdoPayTotalDoc").text());
	//console.log(lTotalDoc);
    var lTotal = 0.00;
	var lTotal2 = 0.00;
    $(".lxCdoPayAmount").each(function () {
        lTotal += lx.util.strToNumber(this.value);
    });
	console.log(lTotal);
	console.log(lx.util.stripNonNumeric(lTotal, false));
	lTotal2 = lTotal.toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,'); 
	//console.log(lx.util.numToString(lTotal2, true));
    $s("lxCdoPayTotal", '-'+lTotal2); /*lx.util.numToString(-lTotal, true)*/
    var lBalance = lTotal - lTotalDoc;
    $s("lxCdoPayBalance", lBalance.toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,')/*lx.util.numToString(lBalance, true)*/);
    if (lBalance < 0) $("#lxCdoPayBalance").addClass("lxCdoPayBalanceLow");
    else $("#lxCdoPayBalance").removeClass("lxCdoPayBalanceLow");
};

/* ex cdoPayDelete function */
lx.cdo.PayDelete = function (pThis) {
    $(pThis).closest(".lxCdoPayNew").remove();
    lx.btn.hightlight('lxCdoPaySave');
    lx.cdo.PaymentUpdateTotal();
};

/* ex submitCdoPayment function */
lx.cdo.submitPayment = function (pClose,pTrigElement,pPage) {
    lx.load.add();
    var abort = false;
	var linkLabel = lx.tran.get('UPDATE_BALANCE');
    $(".lxCdoPayDate").each(function () {
        if (this.value == "") {
            //alert("Please Fill Date of Payment");
			$("#WarningPayBox").show();
            abort = true;
            $(this).focus();
            return;
        }
    });
    $(".lxCdoPayAmount").each(function () {
        if (this.value == "") {
            //alert("Please Fill Amount of Payment");
			$("#WarningPayBox").show();
            abort = true;
            $(this).focus();
            return;
        }
    });
    $(".lxCdoPayType").each(function () {
        if ($(this).val() == "") {
            //lx.info.error("Please Select Type of Payment");
			$("#WarningPayBox").show();
            abort = true;
            $(this).focus();
            return;
        }
    });
    if (abort) {
        lx.load.remove();
        return;
    }
    var lData = $('.lxCdoPayNew').map(function (i, opt) {
        return $(opt).find(".lxCdoPayID").val() + ":" +
            $(opt).find(".lxCdoPayDate").val() + ":" +
            $(opt).find(".lxCdoPayAmount").val() + ":" +
            $(opt).find(".lxCdoPayType").val() + ":" +
            $(opt).find(".lxCdoPayDoc").val();
    }).toArray().join(';');
    var lCdoID = $v("lxCdoID");
    $.ajax({
        url: "wwv_flow.show",
        dataType: "text",
        traditional: true,
        cache: false,
        type: "POST",
        data: {
            p_flow_id: $v("pFlowId"),
            p_flow_step_id: $v("pFlowStepId"),
            p_instance: $v("pInstance"),
            p_request: "APPLICATION_PROCESS=cdoPaymentFormSubmit",
            x01: lCdoID,
            x02: lData
        },
        success: function (d) {
            lx.load.remove();
            var lTotal = $("#lxCdoPayTotal").text();
            var lBalanceS = $("#lxCdoPayBalance").text();
            var lBalance = lx.util.strToNumber(lBalanceS);
			//console.log(lBalance);
			const input = d;
            const [iconClass, docStatus, payment] = input.split('~');
			/*console.log(clas); // john smith
			console.log(stat); // 123 Street
			console.log(lBalanceS+' | '+lBalance+' | '+lTotal+' | '+lx.util.strToNumber(lTotal));*/
			
            if (lBalance < 0 && iconClass == 'lxCdoPayBalanceLow') {$("#lxCdoPayInfoB, #docStat" + lCdoID).addClass(iconClass);$s("docStatus" + lCdoID, linkLabel/*lx.tran.get('OVERDUE')*/);}
			else if (lBalance < 0 && iconClass == 'lxCdoPayBalanceGray') {
		      $("#lxCdoPayInfoB, #docStat" + lCdoID).addClass(iconClass);
			  if (lx.util.strToNumber(lTotal) == 0) {
				  $s("docStatus" + lCdoID, linkLabel /*lx.tran.get('NOT_PAID')*/);
				  //$("#docStatus" + lCdoID).css("font-weight", "400");
				} else {
					$s("docStatus" + lCdoID, linkLabel/*lx.tran.get('PARTIAL')*/);
					$("#lxCdoPayInfoB, #docStat" + lCdoID).removeClass("lxCdoPayBalanceLow"); 
					$("#lxCdoPayInfoB, #docStat" + lCdoID).removeClass("lxCdoPayBalanceGray");
					$("#lxCdoPayInfoB, #docStat" + lCdoID).addClass("lxCdoPayBalanceGray"); 
				    //$("#docStatus" + lCdoID).css("font-weight", "700");
					}
			}
			else if (lBalance > 0) {
				  $("#lxCdoPayInfoB, #docStat" + lCdoID).removeClass("lxCdoPayBalanceLow"); 
				  $("#lxCdoPayInfoB, #docStat" + lCdoID).removeClass("lxCdoPayBalanceGray");
				  $("#lxCdoPayInfoB, #docStat" + lCdoID).addClass("lxCdoPayBalanceLow"); 
				  $s("docStatus" + lCdoID, linkLabel/*lx.tran.get('OVERPAID')*/);
				  //$("#docStatus" + lCdoID).css("font-weight", "700");
				  }
            else {$("#lxCdoPayInfoB, #docStat" + lCdoID).removeClass("lxCdoPayBalanceLow"); 
				  $("#lxCdoPayInfoB, #docStat" + lCdoID).removeClass("lxCdoPayBalanceGray");
				  $s("docStatus" + lCdoID, linkLabel/*lx.tran.get('PAID')*/);
				  //$("#docStatus" + lCdoID).css("font-weight", "700");
			}
			$s("PaymentType" + lCdoID, payment);
            /*$s("docStat" + lCdoID, lBalanceS);
            $s("lxCdoPayInfoP", lTotal);
            $s("lxCdoPayInfoB", lBalanceS);*/
            lx.btn.unhightlight("lxCdoPaySave");
            if (pClose) {
                var vIR;
                if ($(pTrigElement).hasClass("feed-btn")) {
                    $(pTrigElement).remove();
                } else {
                    $(pTrigElement).closest("li").remove();
                };

                //$(".lxCdoPayments").dialog("close");
				lx.dialog.close(".lxCdoPayments");
				if (pPage == 308) {
				  apex.region("IR-COMMERCIAL").refresh();
				} else {
				  location.reload();
				}  
            }
        }
    });
};

lx.refDocs = {
    get: function (pIusId, pThis, pPage, pType) {
        lx.load.add();
        var lPage;
        if (pPage == 0) {
            lPage = 1;
        } else {
            lPage = pPage;
        }
        $.ajax({
            url: "wwv_flow.show",
            dataType: "html",
            traditional: true,
            cache: false,
            type: "POST",
            data: {
                p_flow_id: $v("pFlowId"),
                p_flow_step_id: $v("pFlowStepId"),
                p_instance: $v("pInstance"),
                p_request: "APPLICATION_PROCESS=getRefDocs",
                x01: pIusId,
                x02: lPage,
                x03: pType
            },
            success: function (d) {
                lx.load.remove();
                if ($(".doclinks").length == 0)
                    lx.dialog.open({ id: "refDocs", html: d, title: lx.tran.get('REFERENCES'), maxWidth: "690px" });
                else $(".doclinks").html($(d).html());
            }
        });
    },
    getLinkedDocs: function (pAdtId, pId, pThis) {
        $popup = $(pThis).siblings(".lxDocLinksPopup");
        $(".lxIrPopup:visible").hide();
        if ($popup.length > 0) {
            $popup.show();
        } else {
            $.ajax({
                url: "wwv_flow.show",
                dataType: "html",
                traditional: true,
                cache: false,
                type: "POST",
                data: {
                    p_flow_id: $v("pFlowId"),
                    p_flow_step_id: $v("pFlowStepId"),
                    p_instance: $v("pInstance"),
                    p_request: "APPLICATION_PROCESS=getLinkedDocs",
                    x01: pAdtId,
                    x02: pId
                },
                success: function (d) {
                    $(pThis).after("<div class='lxIrPopup lxDocLinksPopup'><div class='lxIrPopupHdr'>Linked Documents<span onclick='$(this).closest(\".lxIrPopup\").hide();'>x</span></div>" + d + "</div>");
                }
            });
        }
    },
    itemsAccountList: function (pId,pThis,pEdit){
		var lButtons = [];
		 apex.server.process("itemsAccountList", {
            x01: pId
          }, {
            dataType: 'html',
            success: function(d) {
				if (pEdit == 'Y') {
				  lButtons.push({label: lx.tran.get('APPLY_CHANGES'), js: "lx.cdo.itemsAccountListSubmit("+ pId +",this)", class: "t-Button--primary", fa:'far fawe-save'});	
				  lButtons.push({label: lx.tran.get("CANCEL_BTN"), js: "$('.lxpDialog').css('display','none');", fa:'far fawe-times'});
				} else {	
				  lButtons.push({label: lx.tran.get("CLOSE"), js: "$('.lxpDialog').css('display','none');", fa:'far fawe-times'});
				}
				var dialogDiv = "<div class='lxIrPopup lxDocItemsPopup'>"+d+"</div>";
				lx.dialog.open({ id: "ItemsPopup", html: dialogDiv, maxWidth: "690px", buttons: lButtons, title: lx.tran.get('ITEMS_ACCOUNTS')});
            }
          });
    }
};

lx.cdo.itemsAccountListSubmit = function (pId, pThis){
    lx.load.add();
    var vData = "1/2:3/4";
    vData = $(pThis).closest(".lxpDialog__content").find("select").map(function(){return $(this).closest("tr").attr("rid")+"/"+$(this).val();}).get().join(":"); //DocItemsPopup
    apex.server.process("itemsAccountListSubmit", {
      x01: pId,
      x02: vData
    }, {
      dataType: 'json',
      success: function(d) {
        lx.load.remove();
        if (d.status == 'OK'){
            var vClass;
            if (d.cnt == 0) vClass = 'green';
            else if (d.cnt == d.cntTotal) vClass = 'red';
            else vClass = 'orange';
            $(pThis).closest(".lxIrPopupRef").find(".icon_text").text((d.cntTotal - d.cnt)+"/"+d.cntTotal);
        }else alert("Items can't be processed!");
      }
    });
}

lx.doc = {
    preview: (pEtyId, pId, pThis) => {
        if (pEtyId == 27) {
            let lDocId = $(pThis).closest(".lxdoc").attr("data-id");
            console.log(pThis);
            console.log($(pThis).closest(".lxdoc"));
            console.log(lDocId);
            lx.load.add();
            apex.server.process("startDocChecklist", {
                x01: lDocId,
                x02: pId
            }, {
                dataType: 'json',
                success: function(d) {
                    lx.load.remove();
                    window.open(d.link, '_blank');
                }
            });
        } else {
            lx.load.add();
            apex.server.process("docPreview", {
                x01: pEtyId,
                x02: pId
            }, {
                dataType: 'html',
                success: function(d) {
                lx.load.remove();
                $("body").append('<div id="docBox" class="docBox"><div class="hdr"><a href="javascript:void(0)" onclick="lx.doc.close(this);" class="fas fawe-times"></a></div>'+
                                    '<div class="body">'+ d +'</div></div>')
                }
            });
        }
    },
    close: (pThis) => {
        $(pThis).closest('.docBox').remove();
    }
}

/* TODO cleanup */
var getRefDocs    = lx.refDocs.get;
var getLinkedDocs = lx.refDocs.getLinkedDocs;